import { useEffect, useState } from "react";

/**
 * 전국 지하철 한 벌(노선 선·역·출구)을 **한 번만** 받는다.
 *
 * 앞서 출구는 지도를 움직일 때마다 화면 범위로 서버에 물었다. 범위가 매번 달라
 * 캐시가 안 걸리고, 노선까지 그 방식으로 하면 움직임마다 요청이 늘어난다.
 * 전국을 다 합쳐도 gzip 100KB 남짓이라(지도 첫 화면 3,153KB의 3%), 파일 한 벌로
 * 받아 두는 편이 낫다 — 파일 이름에 판 번호가 박혀 있어 1년 캐시가 걸리고,
 * 그 뒤로는 지도를 아무리 움직여도 **요청이 0건**이다.
 *
 * 판을 새로 만들면 아래 이름만 바꾼다(노선도가 바뀌는 일은 몇 년에 한 번이다).
 */
export const SUBWAY_NETWORK_URL = "/map/subway-20260810-3.json";

let cached = null;
let inflight = null;

const load = () => {
  if (cached) return Promise.resolve(cached);
  if (inflight) return inflight;
  inflight = fetch(SUBWAY_NETWORK_URL)
    .then((res) => (res.ok ? res.json() : null))
    .then((data) => {
      cached = data && Array.isArray(data.lines) ? data : null;
      return cached;
    })
    .catch(() => null)
    .finally(() => {
      inflight = null;
    });
  return inflight;
};

export const useSubwayNetwork = ({ enabled = true } = {}) => {
  const [network, setNetwork] = useState(cached);

  useEffect(() => {
    if (!enabled || network) return undefined;
    let alive = true;
    load().then((data) => {
      if (alive && data) setNetwork(data);
    });
    return () => {
      alive = false;
    };
  }, [enabled, network]);

  return network;
};
